export function Dinner() {
    return <section>
      <h2>DINNER SIGN UPS</h2>
      <iframe title="dinner" height="224" src="https://docs.google.com/spreadsheets/d/e/2PACX-1vQSrU_--dI4JbixdmRYf6UlGU57K-2Gx71DHfkxLcZW6BONnDNzRfYL0TMUq6oTg9OuB6BiBVMIfqbR/pubhtml?gid=959323072&amp;single=true&amp;widget=true&amp;headers=false"></iframe>
    </section>;
  }